<!--
 * @Author: your name
 * @Date: 2021-03-25 13:39:12
<<<<<<< HEAD
<<<<<<< HEAD
 * @LastEditTime: 2021-04-22 16:38:43
=======
 * @LastEditTime: 2021-04-09 15:20:22
>>>>>>> 20a81ab... feat: 1
=======
 * @LastEditTime: 2021-04-09 19:19:30
>>>>>>> 03e46ff... feat: 1
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zmbiz-mobile-work-front/src/pages/interviewnew/components/interViewVideo.vue
-->
<template>
  <div>
    <!-- <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div class="block" @click.stop>
          <van-icon class="close" name="cross" @click.stop="show = false" />
          <div class="title">视频面试</div>
          <div class="interview_post">
            面试职位：{{ item.postName || '--' }}
          </div>
          <div class="interview_time">
            面试时间：{{ item.interviewTime || '--' }}
          </div>
          <div @click="previewImage" class="qr-content">
            <vue-qr
              class="qr-image"
              :logoSrc="icon"
              :logoScale="0.16"
              :text="url"
              :size="550"
            ></vue-qr>
          </div>
          <div class="footer">
            <span>微信扫码进行面试</span>
            <span class="save-image" @click.stop="previewImage">保存图片</span>
          </div>
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>

<script>
// import Vue from 'vue';
// import { Overlay, Icon, Toast } from 'vant';
// import * as dd from 'dingtalk-jsapi';
// import VueQr from 'vue-qr';

// Vue.use(Overlay).use(Icon).use(Toast);

import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

const jobUrl = {
  dev: 'https://jobs-wechat.zmaxis.com/employer/wxamp',
  fat: 'https://jobs-wechat.zmaxis.com/employer/wxamp',
  prod: 'https://wechat-job.zmlearn.com/employer/wxamp',
};

export default {
  data() {
    return {
      // show: false,
      // icon:
      //   'https://web-data.zmlearn.com/image/nydJFBCmBcZQzW1cVnHhS9/qrimage-icon%E7%9A%84%E5%89%AF%E6%9C%AC.png',
      // item: {},
    };
  },
  components: {
    // VueQr,
  },
  methods: {
    init(item) {
      if (!item.interviewVideoRoom) return Toast('视频面试房间号缺失 请稍后再试');
      const url = `${jobUrl[process.env.VUE_APP_RUN_ENV]}?roomId=${
        item.interviewVideoRoom
      }`;
      window.open(url, '_self');
    },

    // previewImage() {
    //   location.href = this.url;
    // },
  },
};
</script>

<style lang="scss" scope>
// .wrapper {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 100%;
// }
// .block {
//   width: 640px;
//   background-color: #fff;
//   border-radius: 20px;
//   text-align: center;
//   .close {
//     float: right;
//     top: 30px;
//     right: 30px;
//   }
//   .van-icon-cross::before {
//     color: #999;
//   }
//   .title {
//     margin-top: 50px;
//     font-size: 40px;
//     font-weight: 500;
//   }
//   .interview_post {
//     margin-top: 40px;
//     font-size: 30px;
//     text-align: left;
//     padding-left: 80px;
//     width: 500px;
//     overflow: hidden;
//     white-space: nowrap;
//     text-overflow: ellipsis;
//   }
//   .interview_time {
//     margin-top: 10px;
//     font-size: 30px;
//     text-align: left;
//     padding-left: 80px;
//   }
//   img {
//     width: 500px;
//     height: 500px;
//     margin-top: 40px;
//   }
//   .footer {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     font-size: 30px;
//     margin: 40px 0 80px 0;
//     span {
//       display: block;
//     }
//     .save-image {
//       border: 2px solid #f1524a;
//       border-radius: 36px;
//       padding: 5px 20px;
//       color: #f1524a;
//       font-size: 24px;
//       text-align: center;
//       margin-left: 10px;
//     }
//   }
// }
</style>